var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _a;
import { jsxs, jsx } from "react/jsx-runtime";
import { VisuallyHidden } from "@zillow/constellation";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTheme } from "styled-components";
const Legend = withTheme((_a = class extends Component {
  render() {
    const {
      data,
      hoverIndex,
      yAccessor,
      colors,
      indexFormatter,
      theme,
      fontFamily
    } = this.props;
    const rowStyle = {
      padding: "0 10px 5px",
      textAlign: "left"
    };
    const firstStyle = {
      paddingTop: "5px"
    };
    const dataStyle = {
      fontWeight: "bold",
      textAlign: "right"
    };
    const rows = data.map((d, i) => {
      const dataPoint = d.values[hoverIndex];
      let yVal = hoverIndex ? yAccessor(dataPoint) : null;
      const appliedFirstStyle = i === 0 ? firstStyle : {};
      const pStyle = {
        display: "list-item",
        "list-style": "disc inside",
        "font-size": "15px",
        color: colors(i),
        marginRight: "2px",
        height: "2px",
        width: "3px"
      };
      const thStyle = {
        ...rowStyle,
        ...appliedFirstStyle
      };
      const tdStyle = {
        ...thStyle,
        ...dataStyle
      };
      if (d.formatter) {
        yVal = d.formatter(yVal);
      }
      if (!yVal) {
        return null;
      }
      return /* @__PURE__ */ jsxs("tr", { children: [
        /* @__PURE__ */ jsxs("th", { style: thStyle, children: [
          /* @__PURE__ */ jsx("span", { style: pStyle }),
          /* @__PURE__ */ jsxs("span", { style: {
            "padding-left": "10px"
          }, children: [
            " ",
            d.name,
            " "
          ] })
        ] }),
        /* @__PURE__ */ jsxs("td", { style: tdStyle, children: [
          yVal,
          /* @__PURE__ */ jsx(VisuallyHidden, { children: dataPoint.info })
        ] })
      ] }, d.name);
    });
    const xRowDataStyle = {
      ...rowStyle,
      ...dataStyle,
      fontWeight: "normal",
      fontSize: "10px"
    };
    const formattedX = indexFormatter(hoverIndex);
    const xRowContents = /* @__PURE__ */ jsxs("tr", { children: [
      /* @__PURE__ */ jsx("th", {}),
      /* @__PURE__ */ jsx("td", { style: xRowDataStyle, children: formattedX })
    ] }, "month");
    const xRow = formattedX ? xRowContents : null;
    const boxStyle = {
      position: "absolute",
      top: "15px",
      left: "25px",
      backgroundColor: theme.constellation.colors.borderLight,
      border: `1px solid ${theme.constellation.colors.borderDark}`,
      textAlign: "left",
      fontSize: "10px",
      fontFamily
    };
    if (!xRow) {
      return null;
    }
    return /* @__PURE__ */ jsx("div", { className: "linechart-legend", style: boxStyle, "aria-live": "polite", "aria-atomic": "true", children: /* @__PURE__ */ jsx("table", { children: /* @__PURE__ */ jsxs("tbody", { children: [
      rows,
      xRow
    ] }) }) });
  }
}, __publicField(_a, "propTypes", {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    values: PropTypes.array
  })),
  hoverIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  indexFormatter: PropTypes.func,
  yAccessor: PropTypes.func,
  colors: PropTypes.func,
  theme: PropTypes.object,
  fontFamily: PropTypes.string
}), _a));
export {
  Legend as default
};
